import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { combineLatest, map, Observable, shareReplay, Subscription, tap } from 'rxjs';
import { APIService, KPI } from '../../../../../@core/api';
import { InitiativesService } from '../../../../../@core/utils';
import { AsyncPipe } from '@angular/common';
import { NbListModule } from '@nebular/theme';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-initiative-type-selector',
  standalone: true,
  imports: [
    AsyncPipe,
    NbListModule,
  ],
  templateUrl: './initiative-type-selector.component.html',
  styleUrl: './initiative-type-selector.component.scss'
})
export class InitiativeTypeSelectorComponent implements OnInit, OnDestroy {

  @Input() selectedTypeId: number = null;
  @Input() allowSwitchDirectIndirectCategory = false;
  @Output() public typeSelected = new EventEmitter<KPI.InitiativeType>();

  public showSections: boolean[] = []; // Used to store the indexes of the unfolded sections

  subscriptions: Subscription[] = [];
  public initiativeTypesSections$: Observable<any>;
  private initiativeTypes$: Observable<KPI.InitiativeType[]> = this.initiativesService.initiativeTypes$;
  private emissionCategories$ = this.apiService.get_emission_categories().pipe(shareReplay(1));

  constructor(
    private initiativesService: InitiativesService,
    // private translate: TranslateService,
    private apiService: APIService
  ) {}

  ngOnInit() {
    this.initiativeTypesSections$ = this.initiativeTypes$.pipe(
      map(initiativesTypes => {
        let sections = [];
        const parents = initiativesTypes.filter(type => type.parent === null);
        sections = parents
          .map(parent => {
            const section = {
              parent: parent,
              children: initiativesTypes.filter(type => type.parent === parent.id)
            };
            return section;
          })
        return sections.sort((a, b) => a.ordering - b.ordering);
      }),
      tap(sections => {
        if (this.selectedTypeId) {
          const selectedSectionIndex = sections.findIndex(section => {
            const sectionIncludesSelectedType = section.children.find(type => type.id === this.selectedTypeId);
            return !!sectionIncludesSelectedType;
          });
          if (selectedSectionIndex !== -1) {
            this.toggleVisibility(selectedSectionIndex);
          }
        }
      })
    );
  }

  public selectInitiativeType(selectedType: KPI.InitiativeType) {
    const sub = combineLatest([this.emissionCategories$, this.initiativeTypes$])
      .pipe(
        tap(([emissionCategories, initiativeTypes]) => {
          const initialType = initiativeTypes.find(it => it.id === this.selectedTypeId) || ({} as any);
          const initialCategory = emissionCategories.find(ic => ic.id === initialType.emission_category);
          const newCategory = emissionCategories.find(ic => ic.id === selectedType.emission_category) || ({} as any);
          if (
            initialCategory &&
            initialCategory.is_calculated != newCategory.is_calculated &&
            !this.allowSwitchDirectIndirectCategory
          ) {
            this.showUnableToSwitchCategoriesAlert();
          } else {
            this.selectedTypeId = selectedType.id;
            setTimeout(() => {
              this.typeSelected.emit(selectedType);
            }, 500);
          }
        })
      )
      .subscribe();

    this.subscriptions.push(sub);
  }

  public toggleVisibility(index: number) {
    if (this.showSections[index]) {
      this.showSections[index] = !this.showSections[index];
    } else {
      this.showSections[index] = true;
    }
  }

  private showUnableToSwitchCategoriesAlert() {
    // this.alertCtrl
    //   .create({
    //     header: this.translate.instant("Action type"),
    //     message: this.translate.instant("For the desired action type, please create a new action"),
    //   })
    //   .then(alert => alert.present());
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
